import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import NopePrimitive from './NopePrimitive';
import { urlRegex, emailRegex } from './consts';

var NopeString = /*#__PURE__*/function (_NopePrimitive) {
  _inherits(NopeString, _NopePrimitive);

  var _super = _createSuper(NopeString);

  function NopeString() {
    var _this;

    _classCallCheck(this, NopeString);

    _this = _super.apply(this, arguments);
    _this._type = 'string';
    return _this;
  }

  _createClass(NopeString, [{
    key: "validate",
    value: function validate(entry, context) {
      var value = !!entry ? String(entry) : entry;
      return _get(_getPrototypeOf(NopeString.prototype), "validate", this).call(this, value, context);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      return value === undefined || value === null || "".concat(value).trim().length === 0;
    }
  }, {
    key: "regex",
    value: function regex(_regex) {
      var _this2 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Doesn't satisfy the rule";

      var rule = function rule(entry) {
        if (_this2.isEmpty(entry)) {
          return;
        }

        if (!_regex.test(entry)) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "url",
    value: function url() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input is not a valid url';
      return this.regex(urlRegex, message);
    }
  }, {
    key: "email",
    value: function email() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input is not a valid email';
      return this.regex(emailRegex, message);
    }
    /**
     * @deprecated alias for greaterThan()
     */

  }, {
    key: "min",
    value: function min(length, message) {
      return this.greaterThan(length, message);
    }
    /**
     * @deprecated alias for lessThan()
     */

  }, {
    key: "max",
    value: function max(length, message) {
      return this.lessThan(length, message);
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(length) {
      var _this3 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Input is too short';

      var rule = function rule(entry) {
        if (_this3.isEmpty(entry)) {
          return;
        }

        var value = entry;

        if (value.length <= length) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "lessThan",
    value: function lessThan(length) {
      var _this4 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Input is too long';

      var rule = function rule(entry) {
        if (_this4.isEmpty(entry)) {
          return;
        }

        var value = entry;

        if (value.length >= length) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "atLeast",
    value: function atLeast(length) {
      var _this5 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Input is too short';

      var rule = function rule(entry) {
        if (_this5.isEmpty(entry)) {
          return;
        }

        var value = entry;

        if (value.length < length) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "atMost",
    value: function atMost(length) {
      var _this6 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Input is too long';

      var rule = function rule(entry) {
        if (_this6.isEmpty(entry)) {
          return;
        }

        var value = entry;

        if (value.length > length) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "exactLength",
    value: function exactLength(length) {
      var _this7 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be at exactly of length ".concat(length);

      var rule = function rule(entry) {
        if (_this7.isEmpty(entry)) {
          return;
        }

        var value = entry;

        if (value.length !== length) {
          return message;
        }
      };

      return this.test(rule);
    }
  }]);

  return NopeString;
}(NopePrimitive);

export default NopeString;